import styled from '@emotion/styled';
import {
    boxSizes,
    colors,
    colorVariables,
    fontSizes,
    fontWeights,
    gutterSizes,
} from '../base/theme';
import Dialog from '../dialog/dialog';

export const SelectModalBody = styled.div`
    padding: ${gutterSizes.xlarge};
    box-sizing: border-box;
    padding: ${gutterSizes.xlarge} ${gutterSizes.xlarge} 70px;
    height: 100%;
    max-height: 630px;
    overflow: auto;
`;

export const SelectModalLightbox = styled(Dialog)`
    padding: 0;
    border-radius: ${boxSizes.borderRadius8};
    display: flex;
    flex-wrap: wrap;

    .dialog-title {
        position: sticky;
        left: 0px;
        top: 0px;
        background: white;
        z-index: 5;
        padding-right: 0;
        margin-bottom: 0;
        width: calc(100% - 44px);
    }

    .dialog {
        max-height: 85%;
        min-width: auto;
        width: 100%;

        .dialog-close {
            order: 2;
            height: auto;
            background: white;
            position: sticky;
            border-radius: 0px;
            top: 0px;
            right: 0px;
            z-index: 4;

            .icon.icon--clear {
                top: ${gutterSizes.xlarge};
                right: ${gutterSizes.large18};
                transform: none;
            }
        }
    }

    .dialog-content {
        order: 3;
        width: 100%;
        min-height: 65%;
    }
`;

export const SelectModalClosePanel = styled.div`
    position: sticky;
    z-index: 1;
    height: 0px;
    top: calc(100% - 77px);

    & > div {
        display: flex;
        justify-content: center;
        width: 100%;
        background: ${colors.white};
        border-top: 1px solid ${colorVariables.borderLight};
        padding: ${gutterSizes.large};

        & > button {
            width: 100%;
        }
    }
`;

export const NoResultsScreen = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 90%;
    width: 100%;
    text-align: center;
    color: ${colors.bark};
`;

export const ModalHeader = styled.div<{ searchable?: boolean }>`
    padding: ${gutterSizes.xlarge} 0 ${gutterSizes.xlarge} ${gutterSizes.xlarge};
    box-sizing: border-box;
    position: sticky;
    top: 0;
    left: 0;
    background-color: ${colors.white};
    z-index: 1;

    h2 {
        font-size: ${fontSizes.xlarge};
        margin-bottom: ${(props) => (props.searchable !== false ? gutterSizes.xlarge : 0)};
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: -44px;
        border-bottom: 1px solid ${colorVariables.borderLight};
    }
`;

export const ModalSearchBarWrapper = styled.div<{ modalType?: string }>`
    display: flex;
    justify-content: space-between;
    text-align: center;

    .search-bar {
        flex: 1;
    }

    .search-button {
        transform: translateX(30px);
    }

    ${props => props.modalType === 'post-a-job' && `
        position: relative;
        
        .icon--clear {
            border: none;
            background: none;
            position: absolute;
            right: ${gutterSizes.xxlarge};
            top: 50%;
            transform: translateY(-50%) translateX(-${gutterSizes.xlarge});
            cursor: pointer;
        }
    `}
`;

export const ModalSearchBar = styled.div`
    position: relative;

    .icon--magnifying-glass {
        position: absolute;
        top: ${gutterSizes.medium};
        left: ${gutterSizes.medium};
        color: ${colors.bark80};
    }

    input {
        font-size: ${fontSizes.base};
        @supports (-webkit-touch-callout: none) {
            font-size: 16px;
        }
        padding-left: 50px;
        width: calc(100% + ${gutterSizes.xlarge});
        margin-right: -${gutterSizes.xlarge};

        &::placeholder {
            color: ${colors.bark60};
        }

        &:focus {
            &::placeholder {
                color: ${colors.bark60};
            }
        }
    }

    .icon--clear {
        color: ${colors.bark60};
        right: auto;
        left: calc(100% - ${gutterSizes.large});
    }
`;

export const SearchCancelButton = styled.button`
    background: none;
    border: none;
    color: ${colors.blade};
    font-weight: ${fontWeights.bold};
    cursor: pointer;
    padding: 0;
    font-family: inherit;
    line-height: 2;

    &:hover {
        text-decoration: underline;
    }
`;

// Fixed version components with flex layout
export const FixedSelectModalBody = styled(SelectModalBody)`
    height: auto;
    max-height: none;
    flex: 1;
    min-height: 0;
    padding-bottom: 0;
`;

export const FixedSelectModalLightbox = styled(SelectModalLightbox)`
    flex-direction: column;
    flex-wrap: nowrap;

    .dialog-title {
        position: static;
    }

    .dialog {
        .dialog-close {
            position: static;
        }
    }

    .dialog-content {
        order: unset;
        display: flex;
        flex-direction: column-reverse;;
    }
`;

export const FixedSelectModalClosePanel = styled(SelectModalClosePanel)`
    position: static;
    height: auto;
    top: auto;
`;
